import { ContentSlider } from '../../shared/carousel';

const CarouselItem = ({ item }) => (
    <div className="col-12">
        <div className="p-2">
            <div className="row">
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                    <div className="about-us-image h-100">
                        <img src={item.image} alt="About Us" className="img-fluid h-100 w-100 object-fit-cover rounded" style={{minHeight: '250px'}} />
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="about-us-content">
                        <h5 className="section-title text-start">
                            <span className="section-title-highlight">{item.title.split(' ')[0]}</span>
                            {item.title.split(' ').length > 1 && ' ' + item.title.split(' ').slice(1).join(' ')}
                        </h5>
                    </div>
                    <div className="section-text mt-3">
                        <p className="text-start">{item.description}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const AboutUsSection = (settings) => {
    return (
        <div id="aboutUsSection" className="py-4 about-us">
            <div className="container">
                <ContentSlider 
                    items={settings.slides} 
                    itemCountToShow={1}
                    renderItemTemplate={(item) => <CarouselItem item={item} />} 
                />
            </div>
        </div>
    );
};

export default AboutUsSection;